<template>
  <div id="current-location-carousel">
    <p>Your pathfinder is exploring, you can find them in the tree with this landmark</p>
    <div class="locations">
      <circle-select
        v-for="sorted in sortedLocations"
        :key="sorted.location.id"
        :option="{ fillImage: sorted.location.icon }"
        :class="{ selected: sorted.isSelected }"
        :style="{
          margin: 'auto',
          filter: sorted.isSelected ? 'drop-shadow(0 0 0.25rem gold)' : ''
        }"
      ></circle-select>
    </div>
    <p
      class="change-location"
      @click="changeLocation()"
    >CHANGE LOCATION</p>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import CircleSelect from "@/components/CircleSelect.vue";

  export default {
    name: "CurrentLocationCarousel",
    components: {
      CircleSelect
    },
    computed: {
      ...mapState({
        locations: state => state.locations.locations,
        pathfinder: state => state.pathfinders.pathfinder
      }),
      /**
       * Returns sorted list of locations with selected location in the middle.
       * Return data is formated as such:
       * [{
       *  isSelected: true | false
       *  location: {...}
       * },
       * ...
       * ]
       */
      sortedLocations() {
        const unSorted = this.locations.map(l => Object.assign(l)); // Clone

        const selected = unSorted.splice(
          unSorted.findIndex(l => l.key === this.pathfinder.location),
          1
        );

        const halfLength = Math.ceil(unSorted.length / 2);
        const tail = unSorted.splice(0, halfLength);

        const sorted = unSorted.concat(selected).concat(tail);

        const selectedIndex = sorted.findIndex(
          l => l.key === this.pathfinder.location
        );

        return sorted.map((location, i) => {
          return { isSelected: i === selectedIndex, location };
        });
      }
    },
    methods: {
      changeLocation() {
        this.$router.push({ name: "location" });
      }
    }
  };
</script>

<style lang="scss">
  @import "@/assets/global.scss";
  #current-location-carousel {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      font-size: 1em;
      color: $secondary;
      text-align: center;
    }

    p.change-location {
      font-weight: bold;
      font-size: 0.85em;
    }

    .locations {
      display: flex;
      width: 100%;
      margin-top: 1.5em;
      margin-bottom: 1.5em;
    }

    .is-circle.selected {
      width: 20vw;
      height: 20vw;
    }

    @media only screen and (min-width: 600px) {
      .is-circle {
        width: 10vw;
        height: 10vw;
      }

      .is-circle.selected {
        width: 15vw;
        height: 15vw;
      }
    }
  }
</style>
